import { render } from "./TransferShowComponent.vue?vue&type=template&id=128d8395"
import script from "./TransferShowComponent.vue?vue&type=script&lang=js"
export * from "./TransferShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__